import KTFormInput, { KTFormInputType } from "general/components/OtherKeenComponents/Forms/KTFormInput";
import CustomDropdown2 from "general/components/Others/CustomDropdown2";
import AppColors from "general/constants/AppColors";
import UIHelper from "general/helpers/UIHelper";

const TechnicalAcceptanceProductTableView = ({
    dataName,
    data,
    setData,
    categoriesList,
    categoriesTotal,
    handleGetCategoriesList,
    isDisabled = false,
}) => {
    return (
        <div className="rounded-lg" style={{ border: `1px solid ${AppColors.gray[300]}` }}>
            <div className="table-responsive">
                <table className="table mb-0">
                    <thead>
                        <tr>
                            {[
                                { label: 'Sản phẩm', isRequired: true, className: 'pl-3 rounded-top-left-lg' },
                                // { label: 'Quy cách kỹ thuật', isRequired: true },
                                // { label: 'Hãng sản xuất', isRequired: false },
                                { label: 'Đơn vị tính', isRequired: false },
                                { label: 'Số lượng', isRequired: true },
                                { label: 'Ghi chú', isRequired: false },
                                { label: '', className: 'pr-3 w-40px rounded-top-right-lg' },
                            ].map((col, idx) => (
                                <th
                                    key={idx}
                                    className={col.className ?? ''}
                                    style={{
                                        ...UIHelper.buildFontStyle('600', '12px', AppColors.gray[900]),
                                        backgroundColor: AppColors.gray[100],
                                        borderBottom: `1px solid ${AppColors.gray[300]}`,
                                        borderRight: idx !== 4 && `1px solid ${AppColors.gray[300]}`,
                                    }}
                                >
                                    {UIHelper.buildFormLabel(col.label, col.isRequired)}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data?.map((item, index) => (
                            <tr key={`ROW_${index}`} className="w-100">
                                {/* Sản phẩm */}
                                <td className="border-0 pl-3 pr-0 pb-0 w-50" style={{ minWidth: '300px' }}>
                                    <CustomDropdown2
                                        ignoreConfirmClick
                                        name={`PRODUCT_${dataName}_${index}`}
                                        id={`PRODUCT_${dataName}_${index}`}
                                        toggleElement={
                                            <button
                                                type="button"
                                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                                                        ${isDisabled ? 'disabled' : ''}
                                                        `}
                                            >
                                                {item?.categoryId ? item?.name : 'Chọn sản phẩm'}
                                            </button>
                                        }
                                        selectedValue={item}
                                        dropdownMenuItems={[{ name: 'Sản phẩm', role: 'INVENTORY_PRODUCT' }]}
                                        dropdownMenuClassName="overflow-auto w-100 position-relative"
                                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                                        titleSearchable
                                        getSubItems={async (params) => {
                                            await handleGetCategoriesList(params);
                                            return {
                                                values: categoriesList?.map((category) => ({
                                                    id: category.categoryId,
                                                    name: category.name,
                                                    value: 'CATEGORY_PRODUCT',
                                                    productType: 'CATEGORY_PRODUCT',
                                                    item: { ...category, category: category.name },
                                                })),
                                                total: categoriesTotal,
                                            };
                                        }}
                                        onChange={(value) => {
                                            const selectedItem = value?.item;
                                            if (!selectedItem) return;

                                            const updated = [...data];
                                            updated[index] = {
                                                ...updated[index],
                                                tax: selectedItem.tax ?? 0,
                                                name: selectedItem.name ?? '',
                                                unit: selectedItem.unit ?? '',
                                                priceBeforeTax: selectedItem.price ?? 0,
                                                price: (selectedItem.price ?? 0) * (1 + (selectedItem.taxRate ?? 0)),
                                                taxRate: selectedItem.taxRate ?? 0,
                                                categoryId: selectedItem.categoryId ?? null,
                                                categoryCode: selectedItem.categoryCode ?? null,
                                                categoryType: dataName ?? '',
                                                amountBeforeTax: selectedItem.price ?? 0,
                                                amount: (selectedItem.price ?? 0) * (1 + (selectedItem.taxRate ?? 0)),
                                            };

                                            setData(updated);
                                        }}
                                        defaultValue={{ name: 'Sản phẩm', role: 'INVENTORY_PRODUCT' }}
                                        isDropdownForm
                                        searchable
                                        searchFormClassName="mx-3 my-1 search-form-border"
                                        disabled={isDisabled}
                                    />
                                </td>

                                {/* Quy cách kỹ thuật */}
                                {/* <td className="border-0 pr-0 pb-0" style={{ minWidth: '120px' }}>
                                    <KTFormInput
                                        name={`PRODUCT_${item?.modelId ?? index}_description`}
                                        placeholder="Nhập mô tả"
                                        type={KTFormInputType.text}
                                        showUnit={false}
                                        value={item?.description}
                                        onChange={(value) => {
                                            const updated = [...data];
                                            updated[index].description = value;
                                            setData(updated);
                                        }}
                                    />
                                </td> */}

                                {/* Hãng sản xuất */}
                                {/* <td className="border-0 pr-0 pb-0" style={{ minWidth: '80px' }}>
                                    <KTFormInput
                                        name={`PRODUCT_${item?.modelId ?? index}_brandId`}
                                        placeholder="Nhập tên"
                                        type={KTFormInputType.text}
                                        showUnit={false}
                                        value={_.find(chargeBrandOptions, (brand) => brand?.role === item?.brandId)?.name ?? ''}
                                        onChange={(value) => {
                                            const updated = [...data];
                                            updated[index] = { ...updated[index], brandId: value };
                                            setData(updated);
                                        }}
                                        disabled={true}
                                    />
                                </td> */}

                                {/* Đơn vị tính */}
                                <td className="border-0 pr-0 pb-0" style={{ width: '15%', minWidth: '80px' }}>
                                    <KTFormInput
                                        name={`PRODUCT_${item?.modelId ?? index}_unit`}
                                        placeholder="Nhập đơn vị tính"
                                        type={KTFormInputType.text}
                                        showUnit={false}
                                        value={item?.unit}
                                        onChange={(value) => {
                                            const updated = [...data];
                                            updated[index] = { ...updated[index], unit: value };
                                            setData(updated);
                                        }}
                                        disabled={true}
                                    />
                                </td>

                                {/* Số lượng */}
                                <td className="border-0 pr-0 pb-0" style={{ width: '10%', minWidth: '80px' }}>
                                    <KTFormInput
                                        name={`PRODUCT_${item?.modelId ?? index}_quantity`}
                                        placeholder="Nhập số lượng"
                                        type={KTFormInputType.currency}
                                        showUnit={false}
                                        value={item?.quantity}
                                        onChange={(value) => {
                                            const updated = [...data];
                                            const currentItem = updated[index];

                                            updated[index] = {
                                                ...currentItem,
                                                quantity: Number(value ?? 0),
                                                amountBeforeTax: (currentItem?.price ?? 0) * (value ?? 0),
                                                amount: (currentItem?.price ?? 0) * (value ?? 0) * (1 + (currentItem?.taxRate ?? 0)),
                                            };

                                            setData(updated);
                                        }}
                                        disabled={isDisabled}
                                    />
                                </td>

                                {/* Ghi chú */}
                                <td className="border-0 pr-0 pb-0" style={{ width: '20%', minWidth: '160px' }}>
                                    <KTFormInput
                                        name={`PRODUCT_${item?.modelId ?? index}_note`}
                                        placeholder="Nhập ghi chú"
                                        type={KTFormInputType.text}
                                        value={item?.note}
                                        onChange={(value) => {
                                            const updated = [...data];
                                            updated[index] = { ...updated[index], note: value };
                                            setData(updated);
                                        }}
                                        disabled={isDisabled}
                                    />
                                </td>

                                {/* Xóa */}
                                <td className="border-0 pr-3 pb-0 d-flex flex-column align-items-center justify-content-end">
                                    {UIHelper.buildNegativeButton(
                                        null,
                                        isDisabled
                                            ? null
                                            : () => {
                                                if (data.length === 1) {
                                                    setData([]);
                                                } else {
                                                    setData(_.filter(data, (_, i) => i !== index));
                                                }
                                            },
                                        <i className="fa-regular fa-trash-can" />
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Thêm sản phẩm */}
            <div className="d-flex px-3 my-3">
                {UIHelper.buildNegativeButton(
                    'Thêm sản phẩm',
                    isDisabled
                        ? null
                        : () => {
                            setData([
                                ...data,
                                {
                                    tax: 0,
                                    name: '',
                                    unit: '',
                                    price: 0,
                                    amount: 0,
                                    taxRate: 0,
                                    quantity: 1,
                                    categoryId: null,
                                    categoryCode: null,
                                    categoryType: null,
                                    amountBeforeTax: 0
                                },
                            ]);
                        },
                    <i className="fa-regular fa-circle-plus" />
                )}
            </div>
        </div>
    );
}

export default TechnicalAcceptanceProductTableView;